import { render, staticRenderFns } from "./StrRecruitmentStateAutocomplete.vue?vue&type=template&id=2b645892&scoped=true&"
import script from "./StrRecruitmentStateAutocomplete.vue?vue&type=script&lang=js&"
export * from "./StrRecruitmentStateAutocomplete.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2b645892",
  null
  
)

export default component.exports